import { render, staticRenderFns } from "./AboutOverlay.vue?vue&type=template&id=08254e90&scoped=true&"
import script from "./AboutOverlay.vue?vue&type=script&lang=js&"
export * from "./AboutOverlay.vue?vue&type=script&lang=js&"
import style0 from "./AboutOverlay.vue?vue&type=style&index=0&id=08254e90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08254e90",
  null
  
)

export default component.exports